import { render } from "./PopupComponent.vue?vue&type=template&id=a0ce0ba0&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import "./PopupComponent.vue?vue&type=style&index=0&id=a0ce0ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ce0ba0"]])

export default __exports__